import React__default, { useRef, useState, useEffect } from 'react';
import { debounce } from 'diskho';
import styles from 'ui-components/StickBelowHeader.scss';

var useScrolledPast = function useScrolledPast(ref, headerHeight) {
  var _useState = useState(false),
    isPast = _useState[0],
    setIsPast = _useState[1];
  var onScroll = debounce(function () {
    if (ref.current) {
      var refTop = ref.current && ref.current.getBoundingClientRect().top;
      if (refTop <= headerHeight) {
        setIsPast(true);
      } else {
        setIsPast(false);
      }
    }
  }, 15);
  useEffect(function () {
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    return function () {
      if (onScroll) {
        window.removeEventListener("scroll", onScroll);
      }
    };
  }, [onScroll]);
  return isPast;
};
var StickBelowHeader = function StickBelowHeader(_ref) {
  var children = _ref.children,
    render = _ref.render,
    className = _ref.className;
  var nodeRef = useRef(null);
  var fixed = useScrolledPast(nodeRef, parseInt(styles.headerHeight, 10));
  return /*#__PURE__*/React__default.createElement("div", {
    ref: nodeRef,
    className: className
  }, typeof render !== "undefined" ? render(fixed) : children);
};

export { StickBelowHeader };
//# sourceMappingURL=index.js.map
